module.exports = __webpack_public_path__ + "media/application/images/svgs/sun-9441ece39e810b99136da79cfcca0b7c.svg";